/**
 * Newsletter Popup — Funky Bloom
 * Show after 7s, 30-day cooldown on close, permanent dismiss on subscribe.
 * Integrates with Klaviyo via client-side API.
 */
(function () {
  'use strict';

  var POPUP_KEY = 'fb_newsletter_popup';
  var DELAY_MS = 7000;
  var COOLDOWN_DAYS = 30;

  var overlay = document.getElementById('nl-popup-overlay');
  if (!overlay) return;

  var form = overlay.querySelector('.nl-popup__form');
  var input = overlay.querySelector('.nl-popup__input');
  var cta = overlay.querySelector('.nl-popup__cta');
  var closeBtn = overlay.querySelector('.nl-popup__close');
  var skipBtn = overlay.querySelector('.nl-popup__skip');
  var formContent = overlay.querySelector('.nl-popup__form-content');
  var successEl = overlay.querySelector('.nl-popup__success');
  var klaviyoListId = overlay.dataset.klaviyoList || '';
  var klaviyoCompanyId = overlay.dataset.klaviyoCompany || '';

  // ─── Visibility logic ───
  function shouldShow() {
    var stored = localStorage.getItem(POPUP_KEY);
    if (!stored) return true;
    if (stored === 'subscribed') return false;
    var expiry = parseInt(stored, 10);
    if (isNaN(expiry)) return true;
    return Date.now() > expiry;
  }

  function isExcludedPage() {
    var path = window.location.pathname;
    return path.includes('/checkout') ||
           path.includes('/orders/') ||
           path.includes('/thank_you');
  }

  function show() {
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    input.focus();
  }

  function hide() {
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  function dismissFor30Days() {
    var expiry = Date.now() + COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(POPUP_KEY, expiry.toString());
    hide();
  }

  function dismissPermanently() {
    localStorage.setItem(POPUP_KEY, 'subscribed');
  }

  // ─── Email validation ───
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ─── Klaviyo subscribe ───
  function subscribeToKlaviyo(email) {
    // Use Klaviyo's client API (v3) — public key only, safe for frontend
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCompanyId;

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-02-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    source: 'popup_newsletter'
                  }
                }
              }
            },
            custom_source: 'popup_newsletter'
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: klaviyoListId
              }
            }
          }
        }
      })
    });
  }

  // ─── Form submission ───
  function handleSubmit(e) {
    e.preventDefault();
    var email = input.value.trim();

    if (!isValidEmail(email)) {
      input.classList.add('is-error');
      input.focus();
      return;
    }

    input.classList.remove('is-error');
    cta.disabled = true;
    cta.innerHTML = '<span class="nl-spinner"></span>';

    subscribeToKlaviyo(email)
      .then(function () {
        dismissPermanently();
        formContent.classList.add('is-hidden');
        successEl.classList.add('is-visible');
        setTimeout(hide, 3000);
      })
      .catch(function (err) {
        console.error('Klaviyo subscribe error:', err);
        // Still dismiss — don't block UX on API error
        dismissPermanently();
        formContent.classList.add('is-hidden');
        successEl.classList.add('is-visible');
        setTimeout(hide, 3000);
      });
  }

  // ─── Event listeners ───
  closeBtn.addEventListener('click', dismissFor30Days);
  skipBtn.addEventListener('click', dismissFor30Days);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) dismissFor30Days();
  });

  form.addEventListener('submit', handleSubmit);

  input.addEventListener('input', function () {
    input.classList.remove('is-error');
  });

  // Handle Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
      dismissFor30Days();
    }
  });

  // ─── Init ───
  if (!isExcludedPage() && shouldShow()) {
    setTimeout(show, DELAY_MS);
  }
})();
